import React from "react";
import { Route, Switch } from "react-router-dom";

import SignUp from "./SignUp";
import SignUpp from "./Signer";
import Signer from "./Signer";
import Verification from "./Verification";
import AccountStatus from "./Verification";
import PageNotFound from "./404/PageNotFound";
import Otp from "./Otp";
import EmailRejected from "./EmailStatus/EmailRejected";
import EmailVerified from "./EmailStatus/EmailVerified";
import EmailWarning from "./EmailStatus/EmailWarning";

import ForgotPassword from "./ForgotPassword";

import Verificationnnn from "./Verificationnnn";
import SignUpNumber from "./SignUpNumber";
import { Moment } from "./moment";

import EmailVerification from "./EmailVerification";

import UpdatePassword from "./UpdatePassword";
import NewSignUp from "./NewSignUp";
import ForgetpasswordNew from "./ForgetpasswordNew";
import SignUpRegister from "./SignUpRegister";
import LoginInTheHouse from "./LoginInTheHouse";
import ForgotPasswordji from "./ForgotPasswordji";
import Updatepasswordd from "./Updatepasswordd";
import ContactUs from "./ContactUs";
import SendOtp from "./SendOtp";
import Users from "../secure/Users";
// import OverviewFlow from "../secure/ObdFlow/Components/Flow";
// import ReactPlaye from "./ReactPlayer";

function index(props) {
  return (
    <Switch>
      <Route path="/" exact component={LoginInTheHouse} />

      <Route path="/moment" exact component={Moment} />
      <Route path="/SignUpp" exact component={Signer} />
      <Route path="/login" exact component={SignUpNumber} />
      <Route path="/Signup" exact component={SignUpRegister} />
      <Route path="/Contactus" exact component={ContactUs} />
      <Route path="/VerifyOtp" exact component={SendOtp} />

      <Route path="/accountstatus" exact component={AccountStatus} />
      <Route
        path="/accountstatus/EmailApproved"
        exact
        component={EmailVerified}
      />
      <Route
        path="/accountstatus/EmailRejected"
        exact
        component={EmailRejected}
      />
      <Route
        path="/accountstatus/EmailVerification"
        exact
        component={EmailVerification}
      />
      <Route path="/users" exact component={Users} />
      {/* <Route path="/reactplayer" exact component={ReactPlaye} /> */}
      <Route path="/AccountVerification" exact component={Verificationnnn} />
      {/* <Route path="/forgotpassword" exact component={ForgotPassword} /> */}
      <Route path="/forgotpassword" exact component={ForgotPasswordji} />
      <Route path="/forgot/updatepassword" exact component={Updatepasswordd} />
      <Route path="/accountstatus/EmailWarned" exact component={EmailWarning} />
      {/* <Route path="/dashboard/Flow" exact component={OverviewFlow} /> */}
      <Route path="*" exact component={PageNotFound} />
    </Switch>
  );
}

export default index;
